import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'campaign-step-schedule' }

import { computed } from 'vue'
import { TimePicker } from 'element-ui'
import moment from 'moment-timezone'
import { pickerDateFormat as getPickerDateFormat, pickerTimeFormat as getPickerTimeFormat, formatGroupDate, formatGroupTime } from '@/plugins/dates'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  // true for an ongoing campaign: daily time plus an optional stop date
  ongoing: { type: Boolean, default: false },
  sendMode: { type: String, default: 'now' },
  scheduleDate: { type: String, default: '' }, // yyyy-MM-dd (group wall date)
  scheduleTime: { type: String, default: '' }, // HH:mm (group wall time)
  endsOn: { type: String, default: '' },       // yyyy-MM-dd, ongoing only
  conditionDays: { type: Number, default: 7 }  // ongoing only: days before the birthday
},
  emits: ['update:send-mode', 'update:schedule-date', 'update:schedule-time', 'update:ends-on', 'update:condition-days'],
  setup(__props) {

const props = __props





const conditionDaysLabel = computed(() => {
  const d = Number.isInteger(props.conditionDays) ? props.conditionDays : 0
  return d === 0 ? '0 days' : d === 1 ? '1 day' : `${d} days`
})

const group = JSON.parse(localStorage.getItem('group') || '{}')
const tzName = group.tz_name || 'UTC'
const firstDayOfWeek = Number(group.first_day_of_week) || 1
// The picker helpers take the group's stored format and translate it to
// element-ui tokens; called bare they silently fall back to US defaults.
// dddd prefixes the weekday name when the group shows day of week.
const pickerDateFormat = (group.show_day_of_week ? 'dddd, ' : '') + getPickerDateFormat(group.date_format)
const pickerTimeFormat = getPickerTimeFormat(group.time_format)

function isPastDate(date: Date) {
  const startOfToday = moment.tz(tzName).startOf('day')
  return moment(date).isBefore(startOfToday)
}

const scheduledMoment = computed(() => {
  if (!props.scheduleDate || !props.scheduleTime) return null
  return moment.tz(`${props.scheduleDate} ${props.scheduleTime}`, 'YYYY-MM-DD HH:mm', tzName)
})

const resolvedDisplay = computed(() => {
  const m = scheduledMoment.value
  if (!m || !m.isValid() || !m.isAfter(moment())) return ''
  const iso = m.toISOString()
  return `${formatGroupDate(iso)}, ${formatGroupTime(iso)}`
})

const quietHoursWarning = computed(() => {
  if ((!props.ongoing && props.sendMode !== 'schedule') || !props.scheduleTime) return ''
  const hour = Number(props.scheduleTime.split(':')[0])
  if (hour < 8 || hour >= 20) {
    return 'This send time falls outside typical waking hours. Marketing emails land best between 8:00 and 20:00 in your local timezone.'
  }
  return ''
})

const pastError = computed(() => {
  const m = scheduledMoment.value
  if (m && m.isValid() && !m.isAfter(moment())) {
    return 'The scheduled time must be in the future.'
  }
  return ''
})

return { __sfc: true,props, conditionDaysLabel, group, tzName, firstDayOfWeek, pickerDateFormat, pickerTimeFormat, isPastDate, scheduledMoment, resolvedDisplay, quietHoursWarning, pastError, TimePicker }
}

})